import React from "react";
import bulb from "./bulb.png";
const ReactMarkdown = require("react-markdown");

const styles = () => ({
  backgroundColor: "#ebecee",
  padding: "1em",
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  gridGap: "1em",
  alignItems: "center",
  borderRadius: "5px",
  marginBottom: "1em"
});

const imgStyles = () => ({
  width: "40px"
});

const markdownStyles = () => ({
  marginLeft: "1em"
});

export default (props: { text: string }) => (
  <div style={styles()}>
    <img style={imgStyles()} src={bulb} alt="bulb" />
    <div style={markdownStyles()}>
      <ReactMarkdown styles={markdownStyles()} source={props.text} />
    </div>
  </div>
);
